import BundleEditDialog from "./BundleEditDialog.container";

export default BundleEditDialog;
